export default __webpack_public_path__ + "static/media/Win.3d986d7f.svg";